import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ddfba254"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order-filter"
};
const _hoisted_2 = {
  class: "tag-group"
};
import TagButton from '@/components/TagButton/TagButton.vue';
import { reactive, ref, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFilter',
  setup(__props) {
    const allTag = ref(true);
    const tagsValue = reactive({
      allPadding: false,
      allClosed: false,
      allFinished: false
    });
    const chooseAll = newValue => {
      if (newValue) {
        Object.keys(tagsValue).forEach(key => {
          tagsValue[key] = false;
        });
      } else {
        allTag.value = true;
      }
    };
    watch(tagsValue, () => {
      if (checkChoose()) {
        allTag.value = false;
      }
    });
    const checkChoose = () => {
      return Object.keys(tagsValue).find(key => {
        return !!tagsValue[key];
      });
    };
    return (_ctx, _cache) => {
      const _component_van_sticky = _resolveComponent("van-sticky");
      return _openBlock(), _createBlock(_component_van_sticky, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(TagButton, {
          selected: allTag.value,
          "onUpdate:selected": _cache[0] || (_cache[0] = $event => allTag.value = $event),
          onClick: chooseAll
        }, {
          default: _withCtx(() => [_createTextVNode("全部")]),
          _: 1
        }, 8, ["selected"]), _createVNode(TagButton, {
          selected: tagsValue.allPadding,
          "onUpdate:selected": _cache[1] || (_cache[1] = $event => tagsValue.allPadding = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("进行中")]),
          _: 1
        }, 8, ["selected"]), _createVNode(TagButton, {
          selected: tagsValue.allClosed,
          "onUpdate:selected": _cache[2] || (_cache[2] = $event => tagsValue.allClosed = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("已关闭")]),
          _: 1
        }, 8, ["selected"]), _createVNode(TagButton, {
          selected: tagsValue.allFinished,
          "onUpdate:selected": _cache[3] || (_cache[3] = $event => tagsValue.allFinished = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("已完成")]),
          _: 1
        }, 8, ["selected"])])])]),
        _: 1
      });
    };
  }
});